import { isSiteLanguage, type SiteLanguage } from '../components/pulse-preview/regions';

export const PUBLIC_LANGUAGE_COOKIE = 'pulse-site-language';

export function readPublicLanguage(cookies: string): SiteLanguage | null {
  const value = cookies.split(';').map((part) => part.trim())
    .find((part) => part.startsWith(`${PUBLIC_LANGUAGE_COOKIE}=`))
    ?.slice(PUBLIC_LANGUAGE_COOKIE.length + 1) ?? '';
  return isSiteLanguage(value) ? value : null;
}

export function publicLanguageCookie(language: SiteLanguage, hostname: string, protocol: string) {
  const sharedDomain = hostname === 'publicpulse.com' || hostname.endsWith('.publicpulse.com');
  return `${PUBLIC_LANGUAGE_COOKIE}=${language}; Path=/; Max-Age=31536000; SameSite=Lax${sharedDomain ? '; Domain=publicpulse.com' : ''}${protocol === 'https:' ? '; Secure' : ''}`;
}

export function rememberPublicLanguage(language: string): void {
  if (!isSiteLanguage(language)) return;
  try {
    document.cookie = publicLanguageCookie(language, window.location.hostname, window.location.protocol);
  } catch {
    // Preference storage can be disabled; the current page's language still applies.
  }
}
